import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M0 4a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v.714a1 1 0 1 1-2 0V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2a1 1 0 1 1 0 2H4a4 4 0 0 1-4-4V4Zm10 9a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4v-7Zm4-2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
